exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tribe-box-category .ar[data-v-789a349c] {\n  position: relative;\n}\n.tribe-box-category .ar img[data-v-789a349c] {\n  position: absolute;\n  top: 0px;\n  bottom: 0px;\n  left: 0px;\n  right: 0px;\n  border-radius: 4px;\n  width: 100%;\n  height: 100%;\n  -o-object-fit: cover;\n     object-fit: cover;\n  font-family: \"object-fit: cover;\";\n}\n.tribe-box-category .title[data-v-789a349c] {\n  font-size: 1.5rem;\n  font-weight: 600;\n  letter-spacing: 0;\n  line-height: 2.125rem;\n}", ""]);

// exports
